import React, { useState } from 'react'
import {
  Button,
  Modal,
  TextArea,
  Input
} from '@arnsbogroup/react-voicearchive'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useIntl, FormattedMessage } from 'react-intl'
import messages from './messages'

export default NiceModal.create(({selectedTaskIds, orderId}) => {
  const modal = useModal()
  const { formatMessage } = useIntl()
  const [subject, setSubject] = useState(formatMessage(messages.subject, {orderName: "{{order.name}}"}))
  const [message, setMessage] = useState(formatMessage(messages.message, {orderName: "{{order.name}}", supplierFirstName: "{{supplier.firstname}}"}))
  const [loading, setLoading] = useState(false)

  const onSubmit = () => {
    setLoading(true)
    fetch(`/rest/v2/order/${orderId}/audition-scope-reject`, { 
        method: 'PUT',
        body: JSON.stringify({
          taskIds: selectedTaskIds,
          subject: subject,
          message: message
        }) 
      })
      .then((response) => response.json())
      .then((response) => {
        if (!response.success) {
          toastr.error(response.errors.join(', '))
        } else {
          toastr.success(formatMessage(messages.rejectSuccess))
        }
      })
      .catch((error) => toastr.error(error))
      .finally(() => {
        setLoading(false)
        modal.resolve()
        modal.remove()
      })
  }

  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      title={formatMessage(messages.modalTitle)}
    >
      <div className="space-y-4">
        <div className='space-y-2'>
          <Input
            label={formatMessage(messages.subjectLabel)}
            value={subject}
            onChange={({ target: { value } }) => setSubject(value)}
            disabled={loading}
          />
          <TextArea
            label={formatMessage(messages.messageLabel)}
            value={message}
            onChange={({ target: { value } }) => setMessage(value)}
            disabled={loading}
            rows={6}
          />

          <div className='text-right'>
            <Button onClick={() => onSubmit()}>
              {loading ? <FormattedMessage {...messages.loading} /> : <FormattedMessage {...messages.submit} />}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
})
